// @flow

import { i18n } from 'shared/utils';

export default () => [
  {
    label: i18n.t('Status'),
    name: 'statuses',
    type: 'select',
    multi: true,
    selectOptions: [
      { label: i18n.t('Draft'), value: 'DRAFT' },
      { label: i18n.t('Posted'), value: 'POSTED' },
      { label: i18n.t('Voided'), value: 'VOIDED' },
    ],
  },
  {
    label: i18n.t('Source'),
    name: 'sourceTypes',
    type: 'select',
    multi: true,
    selectOptions: [
      { label: i18n.t('Manual'), value: 'MANUAL' },
      { label: i18n.t('Invoice'), value: 'INVOICE' },
      { label: i18n.t('Payment'), value: 'PAYMENT' },
      { label: i18n.t('Shipment'), value: 'SHIPMENT' },
      { label: i18n.t('Job'), value: 'JOB' },
      { label: i18n.t('Inventory Adjustment'), value: 'INVENTORY_ADJUSTMENT' },
    ],
  },
  {
    label: i18n.t('Entry Date'),
    name: 'entryDate',
    type: 'date-range',
  },
];
